module.exports = __webpack_public_path__ + "static/media/7.541f8e5b.jpg";